<template>
  <div class="teaching-score-input-handle-import">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog :visible.sync="visible"
                    title="批量导入成绩"
                    width="900px">
      <DataImportModule import-url="/workspace/manager/teaching/score/input/schedule/scoreImport"
                        :extra-params="importParams"
                        @dataImportSuccess="onImportSuccess">
        <span slot="external">
          <el-button size="mini"
                     @click="hidePopover">关闭窗口</el-button>
        </span>
      </DataImportModule>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../../elements/grid/DataGridDialog'
import DataImportModule from '../../../../../../../../elements/DataImportModule'
export default {
  name: 'TeachingScoreInputHandleImport',
  components: {
    DataGridDialog,
    DataImportModule
  },
  props: {
    scheduleId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    importParams () {
      return {
        scheduleId: this.scheduleId
      }
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    hidePopover () {
      this.visible = false
    },
    onImportSuccess () {
      this.visible = false
      this.$nextTick(() => {
        this.$emit('refresh')
      })
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-input-handle-import {
    display: inline-block;
  }
</style>
